import qs from 'qs';

import type { BreakDays, PlanningObject, PublicHoliday } from '../types/types';
import { MS_PLANNING_ENDPOINT } from '../variables/GlobalVariables';
import request from './AxiosClient';

function getAllPublicHolidays(
  companyId: string,
  year1: number,
  year2: number
): Promise<PublicHoliday[]> {
  return request
    .get(`${MS_PLANNING_ENDPOINT}/v2/planning/${companyId}/public-holidays`, {
      params: { year1, year2 },
    })
    .then((res) => res?.data);
}

function updatePublicHoliday(companyId: string, publicHolidayKey: string) {
  return request
    .patch(
      `${MS_PLANNING_ENDPOINT}/v2/planning/${companyId}/public-holidays`,
      qs.stringify({ publicHolidayKey })
    )
    .then((res) => res?.data);
}

function getPlanningFromStartAndEndDateByDivision(
  companyId: string,
  divisionIds: string[],
  start: number,
  end: number
): Promise<PlanningObject[]> {
  return request
    .get(
      `${MS_PLANNING_ENDPOINT}/v2/planning/company/${companyId}/${start}/${end}?${divisionIds
        .map((item) => `divisionId=${encodeURIComponent(item)}`)
        .join('&')}`
    )
    .then((res) => res?.data);
}

function getPlanningFromStartAndEndDateByUser(
  companyId: string,
  userId: string,
  start: number,
  end: number
): Promise<PlanningObject> {
  return request
    .get(
      `${MS_PLANNING_ENDPOINT}/v2/planning/company/${companyId}/${userId}/${start}/${end}`
    )
    .then((res) => res?.data);
}

function getExportPlanningFromStartAndEndDateByDivision(
  companyId: string,
  end: number,
  start: number,
  divisionId: string[]
) {
  return request
    .get(
      `${MS_PLANNING_ENDPOINT}/v2/planning/company/${companyId}/${start}/${end}/export?${divisionId
        .map((item) => `divisionId=${encodeURIComponent(item)}`)
        .join('&')}`,
      {
        responseType: 'blob',
      }
    )
    .then((res) => res);
}

function getAllBreakDayByDivision(
  companyId: string,
  divisionId: string,
  startTime: number,
  endTime: number
): Promise<BreakDays[]> {
  return request
    .get(
      `${MS_PLANNING_ENDPOINT}/v2/planning/company/${companyId}/employees/breakdays/${divisionId}/${startTime}/${endTime}`
    )
    .then((res) => res?.data);
}

const PlanningService = {
  getAllPublicHolidays,
  updatePublicHoliday,
  getPlanningFromStartAndEndDateByDivision,
  getExportPlanningFromStartAndEndDateByDivision,
  getAllBreakDayByDivision,
  getPlanningFromStartAndEndDateByUser,
};

export default PlanningService;
